<template lang='pug'>
  b-row
    b-col(xs='12')
      b-card
        div(slot="header")
          b-row
            b-col(xs='10')
              strong {{ tableTitle }}
              small.pl-2 Collection
            c-create-entity(
              :entity='entity'
              :newEntityBtn='newEntityBtn'
              :newEntityRouteName='newEntityRouteName'
            )
        c-index-table(
          :fields='fields'
        )
</template>

<script>
  import cIndexTable from '@/components/Shared/IndexTable.vue'
  import cCreateEntity from '@/components/Shared/CreateEntity.vue'

  export default {
    name: 'StructureIndex',
    components: { cIndexTable, cCreateEntity },
    data: () => {
      return {
        entity: 'structure',
        tableTitle: 'Objects',
        newEntityBtn: 'New object',
        newEntityRouteName: 'New object',
        fields: {
          id: { label: 'ID' },
          type: { label: 'Type' },
          name: { label: 'Name', sortable: true },
          model: { label: 'Model', sortable: true },
          code: { label: 'ID Code', sortable: true },
          actions: { label: 'Actions' }
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Structure/Index.vue